<template>
  <v-app id="app">
    <component v-bind:is="layout">
      <router-view v-bind:layout.sync="layout" />
    </component>
    <!-- <v-snackbar bottom :value="updateExists" :timeout="-1" color="primary">
      An update is available.
      <template v-slot:action="{ attrs }">
        <v-btn
          v-bind="attrs"
          depressed
          color="green darken-1"
          @click="refreshApp"
          >Update</v-btn
        >
      </template>
    </v-snackbar> -->
  </v-app>
</template>

<script>
import { AuthState, onAuthUIStateChange } from "@aws-amplify/ui-components";
// import { Auth } from "aws-amplify";
// import router from "@/router";
import WebsiteLayout from "@/layouts/WebsiteLayout.vue";
// import update from "@/mixins/update";

export default {
  name: "App",
  // mixins: [update],
  async mounted() {
    onAuthUIStateChange((state, user) => {
      switch (state) {
        case AuthState.SignedIn: {
          this.user = user;
          break;
        }
      }
    });
  },
  components: {},
  data: () => ({
    layout: WebsiteLayout,
    company: null,
    user: {},
    authState: undefined,
    unsubscribeAuth: undefined,
  }),
  computed: {},
  watch: {},
  methods: {
    //     async UploadMassData() {
    //       const csvData = `loanType;randValue;periodNumber;period;payment;interest;totalPayment;totalInterest;adminFee;serviceCharge;creditLifeFee;debitOrder;creditType
    // string;string;string;string;string;string;string;string;string;string;string;string;string
    // 2902;409,55;1;Months;409,55;0;409,55;0;0;0;0;0;0
    // 2903;2571,66;3;Months;857,22;0;2571,67;0;0,01;0;0;0;0`;
    //       const parseCsv = (csv) => {
    //         let lines = csv.split("\n");
    //         const header = lines.shift().split(";");
    //         lines.shift();
    //         return lines.map((line) => {
    //           const bits = line.split(";");
    //           let obj = {};
    //           header.forEach((h, i) => (obj[h] = bits[i].trim()));
    //           return obj;
    //         });
    //       };
    //       try {
    //         const data = parseCsv(csvData);
    //         var count = 0;
    //         for (let d in data) {
    //           await DataStore.save(
    //             new LoanType({
    //               // id: data[d].code,
    //               code: parseInt(data[d].loanType),
    //               randValue: parseFloat(data[d].randValue),
    //               periodNumber: parseInt(data[d].periodNumber),
    //               period: data[d].period,
    //               payment: parseFloat(data[d].payment),
    //               interest: parseFloat(data[d].interest),
    //               totalPayment: parseFloat(data[d].totalPayment),
    //               totalInterest: parseFloat(data[d].totalInterest),
    //               adminFee: parseFloat(data[d].adminFee),
    //               serviceCharge: parseFloat(data[d].serviceCharge),
    //               creditLifeFee: parseFloat(data[d].creditLifeFee),
    //               debitOrder: parseFloat(data[d].debitOrder),
    //               creditType: parseInt(data[d].creditType),
    //             })
    //           );
    //           count++;
    //           console.log(count);
    //         }
    //       } catch (err) {
    //         console.log(err);
    //       }
    //     },
    // signOut() {
    //   Auth.signOut()
    //     .then((response) => {
    //       console.log(response);
    //       router.push({
    //         name: "Landing",
    //       });
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // },
  },
  beforeDestroy() {
    this.unsubscribeAuth();
  },
};
</script>
